
import VTable from './VTable';
import MultiGrid from './MultiGrid';
import Grid from './Grid';
import {formatToCellsSpan} from './utils/colSpanRowSpan';

const utils = {
  formatToCellsSpan
};
export default VTable;
export {
  VTable,
  MultiGrid,
  Grid,
  utils
};
